import { styled } from '@mui/material/styles';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

export const SlickSlider = styled(Slider)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const SliderArrow = styled('div')(({ theme, left, right }) => ({
  alignItems: 'center',
  backgroundColor: theme.color.primary.contrast,
  borderRadius: '32px',
  border: `1px solid ${theme.color.grey['400']}`,
  boxShadow: `0px 6px 12px 0px ${theme.color.grey['400']}`,
  display: 'flex !important',
  fontWeight: theme.fontWeight.bold,
  height: '64px',
  justifyContent: 'center',
  left: left ? '-10px' : 'auto',
  position: 'absolute',
  right: right ? '-10px' : 'auto',
  top: '50%',
  transform: 'translate(0, -50%)',
  width: '64px',
  zIndex: 99,
  '&::before': {
    content: '""'
  },
  '& svg': {
    height: '32px',
    width: '32px'
  },
  '&:hover': {
    backgroundColor: theme.color.primary.contrast
  }
}));
